import React from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'

import { formatLatestScan } from '../utils'

const AssetRow = ({asset, onSelect, isSelected}) => {
  return (
    <div className={cn(styles.container, {[styles.selected]: isSelected})} onClick={() => onSelect(asset)}>
      <img src={asset.details.photo} className={styles.image} />
      <div className={styles.details}>
        <div className={styles.name}>{asset.name}</div>
        <div className={styles.description}>{ asset.location || '' } { asset.employee ? `${asset.employee.name} ${asset.employee.surname}` : '' }</div>
      </div>
      <div className={styles.latestScan}>{formatLatestScan(asset.latest_scan)}</div>
    </div>
  )
}

export default AssetRow
